import { QuestionHelper } from '@echodex/uikit'
import { ReactNode } from 'react'
import styled from 'styled-components'
import { maxMediaQueries } from 'utils/theme'

export interface PropsTable {
    thead: {
        name: string
        width?: string
        tooltip?: string
    }[]
    children: ReactNode
    className?: string
    sticky?: boolean
}

const StyledTable = styled.div`
    background-color: transparent;
    ${maxMediaQueries.sm} {
        padding: 8px 12px;
    }
    thead {
        tr {
            /* border-bottom: 1px solid #39393a */
        }
    }
    tbody {
        .internal {
            border-top: 1px solid #39393a;
        }
    }
    th,
    td {
        padding: 14px 0;
        vertical-align: middle !important;
        ${maxMediaQueries.sm} {
            font-size: 14px;
        }
    }
`

const EchodexTable = ({ thead, children, className, sticky }: PropsTable) => {
    return (
        <StyledTable>
            <table className={`w-full ${className}`}>
                <thead className={sticky && 'sticky top-0  bg-gray'}>
                    <tr>
                        {thead.map((item) => (
                            <th
                                key={item.name}
                                style={{ width: item.width ? item.width : undefined }}
                                className="font-medium text-left text-gray1 text-[14px] max-sm:text-[12px] first:pl-4"
                            >
                                <div className="fa-center gap-[2px]">
                                    {item.name}
                                    {item.tooltip && <QuestionHelper placement="top" text={item.tooltip} />}
                                </div>
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>{children}</tbody>
            </table>
        </StyledTable>
    )
}

export default EchodexTable
